import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton } from '@mui/material';
import { deleteTeleHealthTherapy } from 'src/services/telehealth.service';
import { useRouter } from 'src/routes/hooks';
import Iconify from '../iconify';

export default function DeleteTeleHealthDialog({ therapyId ,clinicId}) {
  const [open, setOpen] = React.useState(false);
  const router = useRouter();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onClickDelete = async () => {
    try {
      await deleteTeleHealthTherapy(therapyId,clinicId);
    } catch (error) {
      console.error('Failed to delete telehealth therapy:', error);
    }
    handleClose();
    router.reload();
  };

  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <Iconify icon="tabler:trash" />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="delete-telehealth-dialog-title"
        aria-describedby="delete-telehealth-dialog-description"
      >
        <DialogTitle id="delete-telehealth-dialog-title">
          Delete Tele Health Therapy
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="delete-telehealth-dialog-description">
            Are you sure you want to delete this tele health therapy?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={onClickDelete} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
